import { rollerPattern } from "./Pattren/roller";
import { OxfordPattern } from "./Pattren/sectional/Essentials/Oxford";
import { MadisonPattern } from "./Pattren/sectional/Essentials/Madison";
import { TuscanPattern } from "./Pattren/sectional/Essentials/Tuscan";
import { HamptonPattern } from "./Pattren/sectional/Essentials/Hampton";
import { MadisonPatternNative } from "./Pattren/sectional/Native/Madison";
import { TuscanPatternNative } from "./Pattren/sectional/Native/Tuscan";
import { Sovereign } from "./Pattren/sectional/SelectionSeries/Alumicomp/Sovereign";
import { Caesar } from "./Pattren/sectional/SelectionSeries/Alumicomp/Caesar";
import { Sultan } from "./Pattren/sectional/SelectionSeries/Alumicomp/Sultan";
import { Baron } from "./Pattren/sectional/SelectionSeries/Alumicomp/Baron";
import { RoyalL } from "./Pattren/sectional/SelectionSeries/Alumicomp/Royal (L)";
import { RoyalR } from "./Pattren/sectional/SelectionSeries/Alumicomp/Royal (R)";
import { SovereignSolid } from "./Pattren/sectional/SelectionSeries/Solidsheet/Sovereign";
import { CaesarSolid } from "./Pattren/sectional/SelectionSeries/Solidsheet/Caesar";
import { SultanSolid } from "./Pattren/sectional/SelectionSeries/Solidsheet/Sultan";
import { BaronSolid } from "./Pattren/sectional/SelectionSeries/Solidsheet/Baron";
import { RoyalLSolid } from "./Pattren/sectional/SelectionSeries/Solidsheet/Royal (L)";
import { RoyalRSolid } from "./Pattren/sectional/SelectionSeries/Solidsheet/Royal (R)";
import { RegentSolid } from "./Pattren/sectional/SelectionSeries/Solidsheet/Regent";
import { SovereignMini } from "./Pattren/sectional/SelectionSeries/Solidsheet/Miniorb/Sovereign";
import { CaesarMini } from "./Pattren/sectional/SelectionSeries/Solidsheet/Miniorb/Caesar";
import { SultanMini } from "./Pattren/sectional/SelectionSeries/Solidsheet/Miniorb/Sultan";
import { BaronMini } from "./Pattren/sectional/SelectionSeries/Solidsheet/Miniorb/Baron";
import { RoyalLMini } from "./Pattren/sectional/SelectionSeries/Solidsheet/Miniorb/Royal (L)";
import { RoyalRMini } from "./Pattren/sectional/SelectionSeries/Solidsheet/Miniorb/Royal (R)";
import { RegentMini } from "./Pattren/sectional/SelectionSeries/Solidsheet/Miniorb/Regent";
import { SovereignHoney } from "./Pattren/sectional/SelectionSeries/Solidsheet/Honeycomb/Sovereign";
import { CaesarHoney } from "./Pattren/sectional/SelectionSeries/Solidsheet/Honeycomb/Caesar";
import { SultanHoney } from "./Pattren/sectional/SelectionSeries/Solidsheet/Honeycomb/Sultan";
import { BaronHoney } from "./Pattren/sectional/SelectionSeries/Solidsheet/Honeycomb/Baron";
import { RoyalLHoney } from "./Pattren/sectional/SelectionSeries/Solidsheet/Honeycomb/Royal (L)";
import { RoyalRHoney } from "./Pattren/sectional/SelectionSeries/Solidsheet/Honeycomb/Royal (R)";
import { RegentHoney } from "./Pattren/sectional/SelectionSeries/Solidsheet/Honeycomb/Regent";
import { SovereignPoly } from "./Pattren/sectional/SelectionSeries/Solidsheet/Polycarbonate/Sovereign";
import { CaesarPoly } from "./Pattren/sectional/SelectionSeries/Solidsheet/Polycarbonate/Caesar";
import { SultanPoly } from "./Pattren/sectional/SelectionSeries/Solidsheet/Polycarbonate/Sultan";
import { BaronPoly } from "./Pattren/sectional/SelectionSeries/Solidsheet/Polycarbonate/Baron";
import { RoyalLPoly } from "./Pattren/sectional/SelectionSeries/Solidsheet/Polycarbonate/Royal (L)";
import { RoyalRPoly } from "./Pattren/sectional/SelectionSeries/Solidsheet/Polycarbonate/Royal (R)";
import { RegentPoly } from "./Pattren/sectional/SelectionSeries/Solidsheet/Polycarbonate/Regent";
import { SovereignAlu } from "./Pattren/sectional/SelectionSeries/Solidsheet/Aluminium/Sovereign";
import { CaesarAlu } from "./Pattren/sectional/SelectionSeries/Solidsheet/Aluminium/Caesar";
import { SultanAlu } from "./Pattren/sectional/SelectionSeries/Solidsheet/Aluminium/Sultan";
import { BaronAlu } from "./Pattren/sectional/SelectionSeries/Solidsheet/Aluminium/Baron";
import { RoyalLAlu } from "./Pattren/sectional/SelectionSeries/Solidsheet/Aluminium/Royal (L)";
import { RoyalRAlu } from "./Pattren/sectional/SelectionSeries/Solidsheet/Aluminium/Royal (R)";
import { RegentAlu } from "./Pattren/sectional/SelectionSeries/Solidsheet/Aluminium/Regent";
import { Centerbury } from "./Pattren/sectional/Essentials/Window/Hampton/Centerbury";
import { County } from "./Pattren/sectional/Essentials/Window/Hampton/County";
import { Cascade } from "./Pattren/sectional/Essentials/Window/Hampton/Cascade";
import { Horizon } from "./Pattren/sectional/Essentials/Window/Hampton/Horizon";
import { Sunburst } from "./Pattren/sectional/Essentials/Window/Hampton/Sunburst";
import { Traditional } from "./Pattren/sectional/Essentials/Window/Hampton/Traditional";
import { Waterton } from "./Pattren/sectional/Essentials/Window/Hampton/Waterton";
import { CenterburyOx } from "./Pattren/sectional/Essentials/Window/Oxford/Centerbury";
import { CountyOx } from "./Pattren/sectional/Essentials/Window/Oxford/County";
import { CascadeOx } from "./Pattren/sectional/Essentials/Window/Oxford/Cascade";
import { SunsetOx } from "./Pattren/sectional/Essentials/Window/Oxford/Sunset";
import { SunburstOx } from "./Pattren/sectional/Essentials/Window/Oxford/Sunburst";
import { TraditionalOx } from "./Pattren/sectional/Essentials/Window/Oxford/Traditional";
import { WatertonOx } from "./Pattren/sectional/Essentials/Window/Oxford/Waterton";

export const createPattern = (
  color,
  door,
  design,
  series,
  panelStyle,
  windowstyle,
  material
) => {
  return new Promise((resolve) => {
    let svg = "";

    if (door === "roller") {
      svg = rollerPattern(color);
    } else if (design === "Oxford" && windowstyle === "") {
      svg = OxfordPattern(color);
    } else if (design === "Madison" && series === "Essentials") {
      svg = MadisonPattern(color);
    } else if (design === "Tuscan" && series === "Essentials") {
      svg = TuscanPattern(color);
    } else if (design === "Hampton" && windowstyle === "") {
      svg = HamptonPattern(color);
    } else if (design === "Madison" && series === "Native") {
      svg = MadisonPatternNative(color);
    } else if (design === "Tuscan" && series === "Native") {
      svg = TuscanPatternNative(color);
    } else if (
      design === "Sovereign" &&
      panelStyle === "Alumicomp" &&
      material === "Composite"
    ) {
      svg = Sovereign(color);
    } else if (
      design === "Caesar" &&
      panelStyle === "Alumicomp" &&
      material === "Composite"
    ) {
      svg = Caesar(color);
    } else if (
      design === "Sultan" &&
      panelStyle === "Alumicomp" &&
      material === "Composite"
    ) {
      svg = Sultan(color);
    } else if (
      design === "Baron" &&
      panelStyle === "Alumicomp" &&
      material === "Composite"
    ) {
      svg = Baron(color);
    } else if (
      design === "Royal (L)" &&
      panelStyle === "Alumicomp" &&
      material === "Composite"
    ) {
      svg = RoyalL(color);
    } else if (
      design === "Royal (R)" &&
      panelStyle === "Alumicomp" &&
      material === "Composite"
    ) {
      svg = RoyalR(color);
    } else if (
      design === "Sovereign" &&
      panelStyle === "SolidSheet" &&
      material === "Composite"
    ) {
      svg = SovereignSolid(color);
    } else if (
      design === "Caesar" &&
      panelStyle === "SolidSheet" &&
      material === "Composite"
    ) {
      svg = CaesarSolid(color);
    } else if (
      design === "Sultan" &&
      panelStyle === "SolidSheet" &&
      material === "Composite"
    ) {
      svg = SultanSolid(color);
    } else if (
      design === "Baron" &&
      panelStyle === "SolidSheet" &&
      material === "Composite"
    ) {
      svg = BaronSolid(color);
    } else if (
      design === "Royal (L)" &&
      panelStyle === "SolidSheet" &&
      material === "Composite"
    ) {
      svg = RoyalLSolid(color);
    } else if (
      design === "Royal (R)" &&
      panelStyle === "SolidSheet" &&
      material === "Composite"
    ) {
      svg = RoyalRSolid(color);
    } else if (
      design === "Regent" &&
      panelStyle === "SolidSheet" &&
      material === "Composite"
    ) {
      svg = RegentSolid(color);
    } else if (
      design === "Sovereign" &&
      panelStyle === "SolidSheet" &&
      material === "Mini Orb"
    ) {
      svg = SovereignMini(color);
    } else if (
      design === "Caesar" &&
      panelStyle === "SolidSheet" &&
      material === "Mini Orb"
    ) {
      svg = CaesarMini(color);
    } else if (
      design === "Sultan" &&
      panelStyle === "SolidSheet" &&
      material === "Mini Orb"
    ) {
      svg = SultanMini(color);
    } else if (
      design === "Baron" &&
      panelStyle === "SolidSheet" &&
      material === "Mini Orb"
    ) {
      svg = BaronMini(color);
    } else if (
      design === "Royal (L)" &&
      panelStyle === "SolidSheet" &&
      material === "Mini Orb"
    ) {
      svg = RoyalLMini(color);
    } else if (
      design === "Royal (R)" &&
      panelStyle === "SolidSheet" &&
      material === "Mini Orb"
    ) {
      svg = RoyalRMini(color);
    } else if (
      design === "Regent" &&
      panelStyle === "SolidSheet" &&
      material === "Mini Orb"
    ) {
      svg = RegentMini(color);
    } else if (
      design === "Sovereign" &&
      panelStyle === "SolidSheet" &&
      material === "Honeycomb"
    ) {
      svg = SovereignHoney(color);
    } else if (
      design === "Caesar" &&
      panelStyle === "SolidSheet" &&
      material === "Honeycomb"
    ) {
      svg = CaesarHoney(color);
    } else if (
      design === "Sultan" &&
      panelStyle === "SolidSheet" &&
      material === "Honeycomb"
    ) {
      svg = SultanHoney(color);
    } else if (
      design === "Baron" &&
      panelStyle === "SolidSheet" &&
      material === "Honeycomb"
    ) {
      svg = BaronHoney(color);
    } else if (
      design === "Royal (L)" &&
      panelStyle === "SolidSheet" &&
      material === "Honeycomb"
    ) {
      svg = RoyalLHoney(color);
    } else if (
      design === "Royal (R)" &&
      panelStyle === "SolidSheet" &&
      material === "Honeycomb"
    ) {
      svg = RoyalRHoney(color);
    } else if (
      design === "Regent" &&
      panelStyle === "SolidSheet" &&
      material === "Honeycomb"
    ) {
      svg = RegentHoney(color);
    } else if (
      design === "Sovereign" &&
      panelStyle === "SolidSheet" &&
      material === "Polycarbonate"
    ) {
      svg = SovereignPoly(color);
    } else if (
      design === "Caesar" &&
      panelStyle === "SolidSheet" &&
      material === "Polycarbonate"
    ) {
      svg = CaesarPoly(color);
    } else if (
      design === "Sultan" &&
      panelStyle === "SolidSheet" &&
      material === "Polycarbonate"
    ) {
      svg = SultanPoly(color);
    } else if (
      design === "Baron" &&
      panelStyle === "SolidSheet" &&
      material === "Polycarbonate"
    ) {
      svg = BaronPoly(color);
    } else if (
      design === "Royal (L)" &&
      panelStyle === "SolidSheet" &&
      material === "Polycarbonate"
    ) {
      svg = RoyalLPoly(color);
    } else if (
      design === "Royal (R)" &&
      panelStyle === "SolidSheet" &&
      material === "Polycarbonate"
    ) {
      svg = RoyalRPoly(color);
    } else if (
      design === "Regent" &&
      panelStyle === "SolidSheet" &&
      material === "Polycarbonate"
    ) {
      svg = RegentPoly(color);
    } else if (
      design === "Sovereign" &&
      panelStyle === "SolidSheet" &&
      material === "Aluminium"
    ) {
      svg = SovereignAlu(color);
    } else if (
      design === "Caesar" &&
      panelStyle === "SolidSheet" &&
      material === "Aluminium"
    ) {
      svg = CaesarAlu(color);
    } else if (
      design === "Sultan" &&
      panelStyle === "SolidSheet" &&
      material === "Aluminium"
    ) {
      svg = SultanAlu(color);
    } else if (
      design === "Baron" &&
      panelStyle === "SolidSheet" &&
      material === "Aluminium"
    ) {
      svg = BaronAlu(color);
    } else if (
      design === "Royal (L)" &&
      panelStyle === "SolidSheet" &&
      material === "Aluminium"
    ) {
      svg = RoyalLAlu(color);
    } else if (
      design === "Royal (R)" &&
      panelStyle === "SolidSheet" &&
      material === "Aluminium"
    ) {
      svg = RoyalRAlu(color);
    } else if (
      design === "Regent" &&
      panelStyle === "SolidSheet" &&
      material === "Aluminium"
    ) {
      svg = RegentAlu(color);
    } else if (windowstyle === "Centerbury" && design === "Oxford") {
      svg = CenterburyOx(color);
    } else if (windowstyle === "County" && design === "Oxford") {
      svg = CountyOx(color);
    } else if (windowstyle === "Cascade" && design === "Oxford") {
      svg = CascadeOx(color);
    } else if (windowstyle === "Sunset" && design === "Oxford") {
      svg = SunsetOx(color);
    } else if (windowstyle === "Sunburst" && design === "Oxford") {
      svg = SunburstOx(color);
    } else if (windowstyle === "Traditional" && design === "Oxford") {
      svg = TraditionalOx(color);
    } else if (windowstyle === "Waterton" && design === "Oxford") {
      svg = WatertonOx(color);
    } else if (windowstyle === "Centerbury" && design === "Hampton") {
      svg = Centerbury(color);
    } else if (windowstyle === "County" && design === "Hampton") {
      svg = County(color);
    } else if (windowstyle === "Cascade" && design === "Hampton") {
      svg = Cascade(color);
    } else if (windowstyle === "Horizon" && design === "Hampton") {
      svg = Horizon(color);
    } else if (windowstyle === "Sunburst" && design === "Hampton") {
      svg = Sunburst(color);
    } else if (windowstyle === "Traditional" && design === "Hampton") {
      svg = Traditional(color);
    } else if (windowstyle === "Waterton" && design === "Hampton") {
      svg = Waterton(color);
    } else {
      return resolve(null);
    }

    // Create blob URL
    const svgBlob = new Blob([svg], { type: "image/svg+xml" });
    const url = URL.createObjectURL(svgBlob);

    resolve(url); // ⬅️ now returning the blob URL
  });
};
